import '../index.css';
import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full bg-darkGreen text-white py-4 text-center">
      <p>
        <a href="https://github.com/kibolApp" target="_blank" rel="noopener noreferrer" className="font-bold text-gold">
          ©kibolAPP
        </a> 2024 Legnica Kebab City Tour. Wszelkie prawa zastrzeżone.
      </p>
    </footer>
  );
}
